import { render, staticRenderFns } from "./examineCreateView.vue?vue&type=template&id=0d8f1812&scoped=true"
import script from "./examineCreateView.vue?vue&type=script&lang=js"
export * from "./examineCreateView.vue?vue&type=script&lang=js"
import style0 from "./examineCreateView.vue?vue&type=style&index=0&id=0d8f1812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f1812",
  null
  
)

export default component.exports